var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoClaraDotsBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_2",
    "data-name": "Capa 2",
    viewBox: "0 0 37.83 37.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.91,0C8.47,0,0,8.47,0,18.91s8.47,18.91,18.91,18.91,18.91-8.47,18.91-18.91S29.36,0,18.91,0ZM12.27,18.78v-1.75c0-1.33,1.08-2.41,2.41-2.41h1.75c1.33,0,2.41,1.08,2.41,2.41v1.75c0,1.33-1.08,2.41-2.41,2.41h-1.75c-1.33,0-2.41-1.08-2.41-2.41ZM18.86,31.73c0,.89-.72,1.61-1.61,1.61h-1.17c-.89,0-1.61-.72-1.61-1.61v-1.17c0-.89.72-1.61,1.61-1.61h1.17c.89,0,1.61.72,1.61,1.61v1.17ZM24.36,25.24c0,1.11-.9,2.01-2.01,2.01h-1.46c-1.11,0-2.01-.9-2.01-2.01v-1.46c0-1.11.9-2.01,2.01-2.01h1.46c1.11,0,2.01.9,2.01,2.01v1.46ZM27.66,10.99c0,1.77-1.44,3.21-3.21,3.21h-2.34c-1.77,0-3.21-1.44-3.21-3.21v-2.34c0-1.77,1.44-3.21,3.21-3.21h2.34c1.77,0,3.21,1.44,3.21,3.21v2.34Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoClaraDotsBlue);
export default __webpack_public_path__ + "static/media/logo_clara_dots_blue.32273c01a1200b10e1356cd91d525a2a.svg";
export { ForwardRef as ReactComponent };